/** The `/time/holidays` tabs. Its own module so the route's `validateSearch` does not pull the page into the main chunk. */
export const HOLIDAY_TABS = ['mine', 'calendars', 'list', 'assignments', 'overrides'] as const
export type HolidayTab = (typeof HOLIDAY_TABS)[number]
